export const name = 'gzAnalyticsEvent';

export default function gzAnalyticsEvent() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let directive = {
    restrict: 'A',
    // Use a low priority to ensure our event listeners are registered first.
    // This works because pre-link functions are executed in priority order but post-link functions are
    // executed in reverse order. So, lowest priority has post-link registered first.
    // This ensures the page name is accurate in the case where ng-click and gz-analytics-event
    // is on the same element, or example.
    priority: -1000,
    scope: {},
    controllerAs: 'vm',
    bindToController: true,
    link: gzAnalyticsEventLink,
    controller: gzAnalyticsEventController
  };

  return directive;

  /////////////////

  function gzAnalyticsEventLink(scope, elem, attrs) {

    // Add event
    scope.vm.setEvent(attrs.gzAnalyticsEvent);

    // Add category
    if (attrs.hasOwnProperty('gzAnalyticsCategory')) {
      scope.vm.setCategory(attrs.gzAnalyticsCategory);
    }

    // Add label
    if (attrs.hasOwnProperty('gzAnalyticsLabel')) {
      scope.vm.setLabel(attrs.gzAnalyticsLabel);
    }

    // Add value
    if (attrs.hasOwnProperty('gzAnalyticsValue')) {
      scope.vm.setValue(attrs.gzAnalyticsValue);
    }

    // Add event actions
    if (attrs.hasOwnProperty('gzAnalyticsEventClick')) {
      scope.vm.setUserAction('click');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventSave')) {
      scope.vm.setUserAction('save');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventCancel')) {
      scope.vm.setUserAction('cancel');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventSelect')) {
      scope.vm.setUserAction('select');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventSend')) {
      scope.vm.setUserAction('send');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventDelete')) {
      scope.vm.setUserAction('delete');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventToggle')) {
      scope.vm.setUserAction('toggle');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventOpen')) {
      scope.vm.setUserAction('open');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventClose')) {
      scope.vm.setUserAction('close');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventAdd')) {
      scope.vm.setUserAction('add');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventEdit')) {
      scope.vm.setUserAction('edit');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventConfirm')) {
      scope.vm.setUserAction('confirm');
    }
    else if (attrs.hasOwnProperty('gzAnalyticsEventCreate')) {
      scope.vm.setUserAction('create');
    }

    // Set the event handler
    switch (attrs.gzAnalyticsOn) {
      case 'click':
      case 'blur':
      case 'hover':
        // capture the event to ensure we report before possibly changing views (ensure correct 'page')
        elem[0].addEventListener(attrs.gzAnalyticsOn, () => {
          scope.$apply(scope.vm.reportAnalytics);
        }, true);
        break;
      default:
        // capture the event to ensure we report before possibly changing views (ensure correct 'page')
        elem[0].addEventListener('click', () => {
          scope.$apply(scope.vm.reportAnalytics);
        }, true);
        break;
    }
  }

  // @ngInject
  function gzAnalyticsEventController($gzAnalytics) {

    let vm = this;
    let event = null;
    let eventAction = null;
    let eventObj = {};

    vm.setEvent = setEvent;
    vm.setCategory = setCategory;
    vm.setLabel = setLabel;
    vm.setValue = setValue;
    vm.reportAnalytics = reportAnalytics;
    vm.setUserAction = setUserAction;

    //////////////////////

    function setEvent(anEvent) {
      event = anEvent;
    }

    function setCategory(category) {
      eventObj.category = category;
    }

    function setLabel(label) {
      eventObj.label = label;
    }

    function setValue(value) {
      eventObj.value = value;
    }

    function setUserAction(action) {
      eventAction = action;
    }

    function reportAnalytics() {
      switch (eventAction) {
        case 'click':
          $gzAnalytics.eventClick(event, eventObj);
          break;
        case 'save':
          $gzAnalytics.eventSave(event, eventObj);
          break;
        case 'cancel':
          $gzAnalytics.eventCancel(event, eventObj);
          break;
        case 'select':
          $gzAnalytics.eventSelect(event, eventObj);
          break;
        case 'send':
          $gzAnalytics.eventSend(event, eventObj);
          break;
        case 'delete':
          $gzAnalytics.eventDelete(event, eventObj);
          break;
        case 'toggle':
          $gzAnalytics.eventDelete(event, eventObj);
          break;
        case 'open':
          $gzAnalytics.eventOpen(event, eventObj);
          break;
        case 'close':
          $gzAnalytics.eventClose(event, eventObj);
          break;
        case 'add':
          $gzAnalytics.eventAdd(event, eventObj);
          break;
        case 'edit':
          $gzAnalytics.eventEdit(event, eventObj);
          break;
        case 'confirm':
          $gzAnalytics.eventConfirm(event, eventObj);
          break;
        case 'create':
          $gzAnalytics.eventCreate(event, eventObj);
          break;
        default:
          $gzAnalytics.event(event, eventObj);
          break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/analytics/analytics-event.directive.js